<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    #settings.view
      bf-notice(:message='message' @close='message = ""')

      base-modal#preview-modal( :show='modal.preview' )
        close-button( @click.native='modal.preview = false' )
        landing-preview( v-if='user && biz.id' :biz='biz' :account='account' :settings='settings' )

      transition(name='appear')
        bf-wrapper.max-960
          profile-header( :account='account' )

          bf-wrapper.leadtime
            form( @submit.prevent='set' )
              fieldset
                bf-flex.lead-time.fieldset
                  label {{$t("Lead Time")}}:
                  bf-input.basic
                    input( type='number' v-model='settings.lead' )
                  span {{$t("Minutes")}}
                  bf-button.bright.save-btn( type='submit' )
                    template( v-slot:text ) {{ $t('Save') }}
                p.note
                  | {{$t("Allow customer to make reservation X minutes from now")}}.
                  | {{$t("This setting allows you to have time to respond to customers")}}.
                  | {{$t("If set to 0, the customer can make a reservation right away")}}.
            
          bf-wrapper.paid
            span.title {{ $t("Value Package")}}
            fieldset
              bf-flex.multiple.fieldset
                label {{$t("Multiple reservations in the same time slot")}}
                span
                  input( type='radio' v-model='settings.multiple' :value='true' )
                  label {{$t("Yes")}}
                span
                  input( type='radio' v-model='settings.multiple' :value='false' )
                  label {{$t("No")}}
              p.note {{$t("Allow multiple customers to make reservations in the same time slot")}}.
            
            bf-divider.section.borderless
            fieldset
              bf-flex.preview.fieldset
                h3 {{$t("Merchant Landing Site")}}
                bf-button.wide.bright( @click.native='preview' )
                  template( v-slot:text ) {{$t("Preview")}}

            fieldset
              bf-flex.fieldset
                label {{$t("Main Background")}}:
                span.note ({{$t("This setting is for the entire page")}})
              
              bf-divider.borderless.section
              bf-flex.color.fieldset
                label {{$t("Color")}}:
                bf-input.basic
                  input( type='text' v-model='settings.color' )

              bf-divider.section.borderless
              bf-flex.background.fieldset
                label {{$t("Image")}}:
                .radios
                  .radio.none
                    input( type='radio' v-model='settings.background' :value='5' )
                    label {{$t("None")}}
                  .radio
                    input( type='radio' v-model='settings.background' :value='0' )
                    label
                      img( src='/bgs/0.jpg' )
                  .radio
                    input( type='radio' v-model='settings.background' :value='1' )
                    label
                      img( src='/bgs/1.jpg' )
                  .radio
                    input( type='radio' v-model='settings.background' :value='2' )
                    label
                      img( src='/bgs/2.jpg' )
                  .radio
                    input( type='radio' v-model='settings.background' :value='3' )
                    label
                      img( src='/bgs/3.jpg' )

                  .radio.upload
                    input( ref='upload' style='display:none' type='file' @change='read' )
                    input( type='radio' v-model='settings.background' :value='4' @change='select' )
                    label {{$t("Upload my own (600x600)")}} 
                    .image-preview( @click='select' )
                      img( :src='settings.uploaded' )

            bf-divider.page.borderless
            fieldset
              bf-flex.fieldset
                H5 {{$t("Section Background")}}:
                span.note ({{$t("This setting is for each section in the page")}})

              bf-divider.card.borderless
              .sectionals
                .fieldset
                  label {{$t("Company info Background")}}:
                  color( :value='settings.company' @input='update($event, "company")' )

                .fieldset
                  label {{$t("Customer info Background")}}:
                  color( :value='settings.customer' @input='update($event, "customer")' )

                .fieldset
                  label {{$t("Services Background")}}:
                  color( :value='settings.services' @input='update($event, "services")' )

                .fieldset
                  label {{$t("Coupons Background")}}:
                  color( :value='settings.coupons' @input='update($event, "coupons")' )

            bf-divider.section
            bf-flex.centered
              bf-button.wide.bright( v-if="account.merchant=='value'" type='submit' ) 
                template( v-slot:text ) {{ $t("Save") }}
              bf-button.wide(v-else @click.native='$router.push({ name: "account", params: { preset: "value" }})')
                template(v-slot:text) {{$t("Subscribe to Value Package")}}
                

</template>

<script>
  import { Chrome } from 'vue-color'
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  import ProfileHeader from '@/components/profile-header'
  import LandingPreview from '@/components/modals/landing-preview'
  import BaseModal from '@/components/modals/base'
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'settings.view',

    mixins: [ View ],

    components: {
      ProfileHeader,
      LandingPreview,
      BaseModal,
      CloseButton,
      color: Chrome
    },

    data() {
      return {
        settings: { lead: 0, uploaded: '', company: {}, customer: {}, services: {}, coupons: {} },
        message: '',
        modal: { preview: false }
      }
    },

    computed: {
      ref() {
        return db.collection( 'settings' ).doc( `${this.user.uid}->settings` )
      }
    },

    watch: {
      user( cr, pr ) {
        if ( cr ) this.ref.get().then( snap =>
          this.settings = snap.exists ? snap.data() : { lead: 0 }
        )
      }
    },

    methods: {
      update( e, target ) {
        this.settings[target] = e
      },

      preview() {
        this.modal.preview = true
      },

      select() {
        this.$refs.upload.click()
      },

      read( e ) {
        let file = e.target.files[0]
        let reader  = new FileReader()
        console.log('reading')
        reader.addEventListener('load', () => {
          console.log('load listened')
          const name = file.name
          let img = new Image()
          img.src = reader.result
          
          img.onload = () => {
            let width = img.width
            let height = img.height
            let ratio = img.width / img.height
            if( img.width > 600 ) {
              width = 600
              height = width / ratio
            }
            else if ( img.height > 600 ) {
              height = 600
              width = height * ratio
            }
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')
            ctx.drawImage( img, 0, 0, width, height )
            let reduced = ctx.canvas.toDataURL()
            this.$set( this.settings, 'uploaded', reduced )
          }
        }, false)
        reader.readAsDataURL(file)
      },

      set() {
        this.ref.set( this.settings ).then( () => this.message = this.$t('Settings uppdated!') )
      }
    },

    created() {
      if ( this.user ) this.ref.get().then( snap =>
        this.settings = snap.exists ? snap.data() : { lead: 0 }
      )
    }
  }

</script>

<style lang="stylus" scoped>
  .bf-wrapper.paid
    background white
    border 1px solid lightgray
    border-radius 5px
    text-align center

  .bf-wrapper.leadtime
    background white
    border 1px solid lightgray
    border-radius 5px
    margin 10px 0px

  .title
    font-weight bold
    text-align center
    font-size 30px
    padding 10px
    margin-bottom 20px
    line-height 50px
    
  >>> .vc-chrome
    width 100%

  .close
    position absolute
    top 2vh
    right 2vw
  .sectionals
    display grid
    grid-template-columns repeat( auto-fit, minmax( 240px, 1fr ) )
    grid-gap 40px
    .fieldset
      // text-align center
      label
        display block
        margin 16px 0

  .color
    align-items center

  .radios
    display grid
    grid-template-columns 1fr 1fr 1fr 1fr 1fr
    grid-gap 20px
    @media(max-width: 560px)
      grid-template-columns 1fr 1fr 1fr
      grid-gap 10px

  .radio
    display flex
    img
      width 80px
      height 80px
    @media(max-width: 560px)
      img 
        width 60px
        height 60px
    &.upload
      grid-column span 3
    &.upload, &.none
      input
        margin-right 4px
        position relative
        bottom 1.5px
    input
      // margin-right 4px

  .image-preview
    cursor pointer
    
  .fieldset
    justify-content flex-start
    &.lead-time
      align-items center
      .save-btn
        margin-left auto
    .bf-input
      margin 0 1em
      width 100px
    span
      margin 0 1em
      display inline-block
      label
        margin-left .25em
        position relative
        bottom 1px
    h3
      margin-right 1em
  .note
    font-size 1.1em
    color rgb( 60 60 60 )
    
  span.note
    margin-left 1em

  p
    margin 1em 0
    line-height 1.5

  #settings
    form
      // text-align center
      
    input[type=number]
      width 4em
      
    label
      font-weight bold
</style>
